import moment from "moment";
import { useState } from "react";
import { GoMute } from "react-icons/go";
import { MdList } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import NewChatModal from "./NewChatModal";

const ChatList = ({ chats, typingChat = [], refresh }) => {
  const navigate = useNavigate();
  const handleChatClick = (chatId) => {
    navigate(`/chat/${chatId}`);
  }
  const [newChatModal, setNewChatModal] = useState(false);

  const handleNewChat = () => {
    setNewChatModal(true);
  }

  return (
    <div className="flex flex-col h-full bg-white border-r w-full md:w-72 lg:w-80">
      <div className="p-4 border-b flex items-center justify-between bg-white sticky top-0 z-10">
        <div className="flex items-center gap-2">
          <MdList size={22} className="text-indigo-600" />
          <h2 className="font-bold text-lg text-gray-800">Chats</h2>
        </div>
        <button
          className="p-2 bg-indigo-50 text-indigo-600 hover:bg-indigo-100 rounded-lg transition-colors"
          onClick={handleNewChat}
          title="New Group"
        >
          <span className="text-xl">+</span>
        </button>
      </div>

      <div className="flex-1 overflow-y-auto custom-scrollbar p-2">
        {chats?.map((chatItem, i) => (
          <div
            key={i}
            className="flex items-center gap-3 p-3 mb-2 rounded-xl hover:bg-indigo-50/50 cursor-pointer transition-all duration-200 group relative border border-transparent hover:border-indigo-100"
            onClick={() => handleChatClick(chatItem?.id)}
          >
            <div className="relative">
              <img
                src={chatItem?.image || "https://placehold.co/400"}
                className="w-12 h-12 rounded-xl object-cover shadow-sm"
                alt="chat"
              />
              {chatItem?.unread_count > 0 && (
                <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-indigo-600 text-[10px] font-bold text-white border-2 border-white">
                  {chatItem?.unread_count}
                </span>
              )}
            </div>
            
            <div className="flex-1 min-w-0">
              <div className="flex justify-between items-baseline mb-0.5">
                <p className={`text-sm truncate ${chatItem?.unread_count > 0 ? "font-bold text-gray-900" : "font-semibold text-gray-700"}`}>
                  {chatItem?.name}
                </p>
                <span className="text-[10px] text-gray-400 whitespace-nowrap ml-2">
                  {moment(chatItem?.last_msg?.created_at).format("hh:mm a")}
                </span>
              </div>
              
              <div className="flex items-center justify-between">
                {typingChat?.map(itm => itm?.id)?.includes(chatItem?.id) ? (
                  <p className="text-xs text-indigo-500 font-medium animate-pulse">Typing...</p>
                ) : (
                  <p className="text-xs text-gray-500 truncate pr-2">
                    {chatItem?.last_msg?.message || "No messages yet"}
                  </p>
                )}
                {chatItem?.mute && <GoMute size={14} className="text-gray-400 flex-shrink-0" />}
              </div>
            </div>
          </div>
        ))}
      </div>

      {newChatModal && (
        <NewChatModal
          onClose={() => setNewChatModal(false)}
          onCreate={refresh}
        />
      )}
    </div>
  );
}

export default ChatList;